<template>
<div id="footer-bottom-id" class="footer-bottom" :style="{
            'bottom': `-${this.footerHeight}px`}">

  <div class="container">
    <div class="row">
      <div class="mobilefooterlogo">
        <section class="footer-logo"><a class="gaclick" data-vars-ec="Footer" data-vars-el="OpenAgent Logo - OpenAgent.com.au" data-vars-ea="Click Logo" href="/">
            <img src="@/assets/styles/frontend-library/images/openagent-logo-mono.png">
          </a>
          <ul>
            <li>Ⓒ 2019</li>
            <li><a href="/privacy-policy" rel="nofollow">Privacy Policy</a></li>
            <li><a href="/terms" rel="nofollow">Terms and Conditions</a></li>
            <li><a href="/sitemap">Site Map</a></li>
          </ul>
          <p class="legal ut-mt-8" v-html="this.footerbody"></p>
        </section>
      </div>
    </div>

  </div>

</div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    footerlegal: null,
  },
  data() {
    return {
      footerHeight: null,
      footerbody: null,
    };
  },
  computed: {
  },
  created() {
    this.footerbody = decodeURIComponent(this.footerlegal.snippetbody);
  },
  mounted() {
    let footerSectionDOM = document.getElementById("footer-bottom-id");
    this.footerHeight = footerSectionDOM ? footerSectionDOM.offsetHeight : 0;
  },
};
</script>

<style lang="scss" scoped>
.footer-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #272d33;
}

.footer-bottom .footer-logo {
    padding: 35px 0 20px;
}

.footer-bottom .footer-logo a img {
    display: block;
    margin: 0 auto;
    width: 197px;
}

.footer-bottom .footer-logo ul {
    text-align: center;
    padding: 0;
    margin: 0;
}

.footer-bottom .footer-logo ul li {
    display: inline-block;
    font-size: 10px;
    margin-right: 10px;
    color: #fff;
}

.footer-bottom .footer-logo ul li a {
    color: #aab2b9;
}

p.legal {
    max-width: 650px;
    color: #aab2b9;
    font-size: 12px;
    padding: 0 15px;
}
</style>
